import { generateUtilityClass, generateUtilityClasses } from '../../styles/classes';
export var dropdownMenuGroupComponentName = 'QuantumDropdownMenuGroup';
export function getDropdownMenuGroupUtilityClass(slot) {
    return generateUtilityClass(dropdownMenuGroupComponentName, slot);
}
export var dropdownMenuGroupClasses = generateUtilityClasses(dropdownMenuGroupComponentName, ['title']);
